<template>
    <transition name="modal">
      
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <br>
              <div class="grid-container">
                <div class="grid-item" id="contenedorlabel">
                  <label id="nombretextbox">Nombre</label>
                </div>
                <div class="grid-item" id="contenedortextbox">
                  <input type="text" id="textbox" v-model="nombre">
                </div>
              </div>
              <div class="grid-container">
                <div class="grid-item" id="contenedorlabel">
                  <label id="nombretextbox">Edad</label>
                </div>
                <div class="grid-item" id="contenedortextbox">
                  <input type="text" id="textbox" v-model="edad">
                </div>
            
              </div>
              <div class="grid-container">
                <div class="grid-item" id="contenedorlabel">
                  <label id="nombretextbox">Url</label>
                </div>
                <div class="grid-item" id="contenedortextbox">
                  <input type="text" id="textbox" v-model="url"/>
                </div> 
              </div>
              <br>
              <div class="grid-container">
                <div class="grid-item">
                  <label>Robot</label>
                  <br>
                  <input type="radio" id="robot" value="Robot" v-model="modo" name="modo">
                </div>
                <div class="grid-item">
                  <label>Tablet</label>
                  <br>
                  <input type="radio" id="tablet" value="Tablet" v-model="modo" name="modo">
                </div>
                <div class="grid-item">
                  <label>Grabar</label>
                  <br>
                  <input type="checkbox" id="checkbox" v-model="grabar">
                </div>
              </div>
              <form id="my-form" @submit.prevent="iniciarSesion">
                <div class="grid-container" id="contenedorSE">
                  <div id="contenedorSala">
                    <label>Sala</label>
                    <br>
                    <input type="text" v-model="sala" id="textbox"/>
                  </div>
                  <div id="contenedorEscuela">
                    <label>Escuela</label>
                    <br>
                    <input type="text" v-model="escuela" id="textbox"/>
                  </div>
                  <input type="submit" name="name" hidden="true"/>
                </div>
              </form>
              <div class="grid-container" id="contenedorSE">
                <div>
                  <button type="submit" form="my-form" class="button1" >Enviar</button>
                </div>
                <div>
                  <button class="button2" @click="$emit('close')">Cancelar</button> 
                </div>
              </div>
              <div v-if="message">
                <label id="mensaje">Conexión Fallida</label>
              </div>
              
            </div>
          </div>
        </div>
      </transition>
</template>
<script>
  import axios from "axios";
  export default{
    data(){
      return{
        Url:'',
        Usuario: '',
        Password: '',
        modo: 'Tablet' ,
        grabar: false,
        url: localStorage.getItem("urlm",this.url),
        sala: localStorage.getItem("salam",this.sala),
        escuela: localStorage.getItem("escuela",this.escuela),
        message: false, 
      }
    },

   
    methods:{
      close(){
        this.$emit('close',false);
      },
      async iniciarSesion()
      {
          console.log(localStorage.getItem("comprobar"));
          localStorage.removeItem("grabar");
          localStorage.setItem("nombreP",this.nombre);
          localStorage.setItem("edadP",this.edad);
          localStorage.setItem("urlm",this.url);
          localStorage.setItem("modom",this.modo);
          localStorage.setItem("grabar",this.grabar);
          localStorage.setItem("salam",this.sala);
          localStorage.setItem("escuela",this.escuela);
            var payload = {
            username: 'kavelino',
            password: 'Joseph2905',
     
          };
          var data = null;
          try {
            await axios.post(localStorage.getItem("urlm") + '/lolyapi/v1/auth/login', payload)
            .then (response =>{
              localStorage.setItem("token",response.headers.authorization);
              this.close();
            });
          } catch (error) {
            this.message = true;
          }
      },
      

    },
    
    
  }
  </script>

<style>

#contenedorSE{
  display: grid;
  grid-template-columns: auto auto;
  gap: 10px;
  padding: 10px;
}

#contenedorSE > div{
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  height: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}



/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

#contenedorlabel{
  width: 150px;
  text-align: left;
}

#nombretextbox{
  margin-left: 10px;
}
#contenedortextbox{
  width: 330px;
}

#contenedortextbox #textbox{
  width:100%;
  margin-bottom: 5px;
  height: 30px;
}

#contenedorSala #textbox{
  width:75%;
  margin-bottom: 5px;
  height: 30px;
}

#contenedorEscuela #textbox{
  width:75%;
  margin-bottom: 5px;
  height: 30px;
}
.grid-container {
  display: grid;
  grid-template-columns: auto auto auto;
  text-align: center;
  align-items: center;
  
}
.label{
  text-align: center;
}
#mensaje{
  color: red;
}
.button1 {
    background-color: #4CAF50; /* Green */
    border: none;
    color: white;
    padding: 15px 58px;
    text-decoration: none;
    font-size: 12px;
    border-radius: 8px;
}
.button2 {
    background-color: rgba(226, 70, 70, 0.926); /* Green */
    border: none;
    color: white;
    padding: 15px 50px;
    text-decoration: none;
    font-size: 12px;
    border-radius: 8px;
}

</style>